import { render, staticRenderFns } from "./MobileBar.vue?vue&type=template&id=2a6ffb09"
import script from "./MobileBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileBar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports